<script setup lang="ts">
defineOptions({ name: 'AuthSetup' })
import { useDisplay } from 'vuetify'
import { useSso } from '../sso'
import AuthAccount from './AuthAccount.vue'
const { mobile } = useDisplay({ mobileBreakpoint: 761 })
const { setupData, showManualKey, copied, copySecret, continueToMfa } = useSso()
</script>
<template>
  <div class="sso-form sso-form--setup">
    <auth-account></auth-account>

    <div>
      <h2 class="sso-section-title">Налаштуйте Microsoft Authenticator</h2>
      <p class="sso-section-description sso-desktop-only">
        Для захисту облікового запису потрібна двофакторна автентифікація. Це
        робиться один раз.
      </p>
      <p class="sso-section-description sso-mobile-only">
        Двофакторна автентифікація налаштовується один раз.
      </p>
    </div>

    <ol v-if="!mobile" class="sso-steps">
      <li>Встановіть застосунок Microsoft Authenticator на телефон.</li>
      <li>
        У застосунку натисніть «+», оберіть «Робочий або навчальний обліковий
        запис» і «Сканувати QR-код».
      </li>
      <li>Наведіть камеру на код нижче.</li>
    </ol>
    <ol v-else class="sso-steps">
      <li>Встановіть Microsoft Authenticator на телефон.</li>
      <li>
        Натисніть «+» → «Робочий або навчальний обліковий запис» → «Сканувати
        QR-код».
      </li>
      <li>Відскануйте код нижче.</li>
    </ol>

    <img
      v-if="setupData?.qrCodeUrl"
      :src="setupData.qrCodeUrl"
      alt="QR-код для налаштування Microsoft Authenticator"
      class="sso-qr align-self-center" />

    <v-btn
      v-if="setupData?.secret && !showManualKey"
      class="sso-text-button align-self-center"
      color="primary"
      variant="text"
      @click="showManualKey = true">
      <span class="sso-desktop-only">
        Не вдається відсканувати? Ввести ключ вручну
      </span>
      <span class="sso-mobile-only">Ввести ключ вручну</span>
    </v-btn>

    <v-sheet
      v-else-if="setupData?.secret"
      border
      class="sso-secret"
      color="blue-grey-lighten-5"
      rounded="lg">
      <p>У застосунку оберіть «Ввести код вручну» та вкажіть дані:</p>
      <div>
        <span class="sso-secret__label">Обліковий запис</span>
        <div>{{ setupData.accountName }}</div>
      </div>
      <div class="sso-secret__value-row">
        <div>
          <span class="sso-secret__label">Секретний ключ</span>
          <div class="sso-secret__value">{{ setupData.secret }}</div>
        </div>
        <v-btn
          class="sso-secret__copy"
          color="primary"
          height="36"
          variant="outlined"
          @click="copySecret">
          {{ copied ? 'Скопійовано' : 'Копіювати' }}
        </v-btn>
      </div>
    </v-sheet>

    <v-btn
      block
      class="sso-submit"
      color="primary"
      :disabled="!setupData"
      @click="continueToMfa">
      Далі
    </v-btn>
  </div>
</template>
